import { Component, Vue } from 'vue-property-decorator';
import LogoBar from '@/components/LogoBar/LogoBar'

@Component<ParticipateAr>({
  components: {
    LogoBar,
  },
})
export default class ParticipateAr extends Vue {

  public mounted() {
    //
  }

}
